import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router';

const MobileFooterButton = (props) => {
  const { btn } = props;
  const history = useHistory();

  const handleClick = (e) => {
    if (btn.url && btn.url.startsWith('/')) {
      e.preventDefault();
      e.stopPropagation();
      history.push(btn.url);
    }
  };

  return (
    <div className="mobile-footer-button">
      <a className="button is-medium" href={btn.url} onClick={handleClick}>
        {btn.label}
      </a>
    </div>
  );
};

MobileFooterButton.defaultProps = {
  btn: {},
};

MobileFooterButton.propTypes = {
  btn: PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string,
  }),
};

export default MobileFooterButton;
